<template>
    <div id="lightbox">
        <div id="container">
            <!--<ul id="btn-cart">
                <li><a class="black-white" href="#"><img src="@/assets/img/refresh.png"></a></li>
                <li><a class="black-white" href="#"><img src="@/assets/img/addcart.png"></a></li>
            </ul>-->
            <a class="black-white" href="#" id="btn-close" ref="btn-close" v-on:click="exit"><img src="@/assets/img/x_24_1.png"></a>

            <h1 v-html="title"></h1>

            <div id="conteudo">
                <div class="container-1">
                <iframe v-show="view_iframe" scrolling='no' class="responsive-iframe" id="iframe" ref="iframe" src="" allow="camera;microphone"></iframe>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
    export default {
        name: "LightBox",
        data() {
            return {
                title: '',
                view_iframe:false
            }
        },
        computed: {
            ...mapGetters([
                'token', 'logged', 'counter', 'id', 'first_name', 'last_name', 'email', 'points', 'level', 'level_next', 'score_needed_to_reach', 'thumb', 'check_log', 'sustentavel', 'produtos_3d'
            ])
        },
        methods: {
            start(id, title_, type_) {
                console.log('start');
                this.title = title_;
                
                if (type_ === '3d') {
                    if (this.produtos_3d.indexOf(id) !== -1) {
                        this.$refs['iframe'].src = 'https://fashion.vrglass.com/renner/3d/' + id + '.html';
                    }
                    /*else {
                        this.$refs['iframe'].src = 'https://vrglass.com/renner/3d/2.html';
                    }*/
                } else {
                    if (id == '10103') {
                        this.$refs['iframe'].src = 'https://fashion.vrglass.com/jeelizFaceFilter-master/demos/threejs/VTO/';
                    } else if (id == '550047891'){
                        this.$refs['iframe'].src = 'https://fashion.vrglass.com/news/oracle/avatar/';
                    }
                }

                this.view_iframe = true;
            },
            exit(e) {
                this.view_iframe = false;
                this.$refs['iframe'].src = '';
                this.$parent.view_lightbox = false;
                e.preventDefault();
            }
        },
        mounted() {
            
        }
    }
</script>

<style scoped>
    #lightbox
    {
        background-color: rgba(0, 0, 0, .6);
        height: 100%;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        overflow-y:auto;
    }
    #container
    {
        background-color: #fff;
        border-radius: 14px;
        box-shadow: 2px 2px 2px rgba(0, 0, 0, .1);
        box-sizing: border-box;
        display: block;
        margin: 150px auto;
        max-width: 1200px;
        min-height: 300px;
        padding: 30px;
    }
    h1
    {
        text-align: center;
    }

    #conteudo {
        box-sizing: border-box;
        padding: 15px 0;
    }


    /*----- btns -----*/
    .black-white
    {
        background-color: black;
        border-radius: 22px;
        box-sizing: border-box;
        display: block;
        height: 44px;
        padding: 10px;
        width: 44px;
    }
    .black-white img
    {
        filter: brightness(0) invert(1);
        height: 24px;
        width: 24px;
    }

    #btn-close
    {
        float: right;
    }

    #btn-cart
    {
        float: left;
    }
    #btn-cart li
    {
        display: inline-block;
        margin-right: 8px;
    }
    /*----- \btns\ -----*/



    .container-1 {
        position: relative;
        overflow: hidden  !important;
        width: 100%;
        padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
        }

        /* Then style the iframe to fit in the container div with full height and width */
        .responsive-iframe {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
        overflow: hidden !important;
        }


    @media screen and (max-width: 1000px)
    {
        #container
        {
            width: calc(100% - 40px);
        }
    }
    
</style>